// extracted by mini-css-extract-plugin
export default {"credits":"doc_cre_1BIxl","date":"doc_dat_1OMXW","items":"doc_ite_22-YK","button":"doc_but_36KXb"};